import { connect } from 'react-redux';
import Distribution from './distribution';
import { setTaxKeyId,
  setInvoiceUser,
  setLockAmountDistribution,
  setAmount,
  setAmountIncVat
} from 'redux/modules/invoice/index';

function mapStateToProps (state) {
  return {
    taxkeys: state.taxkeys,
    invoice: state.invoice,
    user: state.user
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTaxKeyId: (taxkeyId) => dispatch(setTaxKeyId(taxkeyId)),
    setInvoiceUser: (invoiceUsers) => dispatch(setInvoiceUser(invoiceUsers)),
    setAmount: (invoiceAmount) => dispatch(setAmount(invoiceAmount)),
    setAmountIncVat: (amountIncVat) => dispatch(setAmountIncVat(amountIncVat)),
    setLockAmountDistribution: (lockAmountDistribution) =>
      dispatch(setLockAmountDistribution(lockAmountDistribution))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Distribution);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/distribution-container.js
 **/